import { ChangeEvent, forwardRef, useEffect, useState } from 'react';
import { Input } from '../Input/Input';
import { AppHelper } from '@/Domain/helper/App.helper';

type SingleUrlInputProps = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onError?: (error: string | null) => void;
  handleUrlBlur?: () => void;
  error?: boolean;
  disabled?: boolean;
};

export const SingleUrlInput = forwardRef<HTMLInputElement, SingleUrlInputProps>(
  ({ value, placeholder, onChange, onError, handleUrlBlur, error, disabled }, ref) => {
    const [displayValue, setDisplayValue] = useState('');
    useEffect(() => {
      if (value) {
        const strippedValue = AppHelper.stripProtocol(value);
        setDisplayValue(strippedValue);
      }
    }, []);

    const handleUrlChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      const strippedValue = AppHelper.stripProtocol(newValue);

      setDisplayValue(strippedValue);
      onChange(AppHelper.addProtocol(strippedValue));

      if (onError) {
        onError(null);
      }
    };

    return (
      <div className="flex items-center rounded-lg border border-input bg-card [&>div]:focus-within:!border-input [&>div]:focus-within:!ring-0">
        <div className="border-r border-border px-3 py-2 text-muted-foreground">https://</div>
        <Input
          ref={ref as React.Ref<HTMLInputElement>}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleUrlChange}
          onBlur={handleUrlBlur}
          className="w-full border-0 shadow-none !focus-within:border-input !focus-within:ring-0 focus-within:!border-input focus-within:!ring-0"
          error={error}
          disabled={disabled}
        />
      </div>
    );
  },
);
